// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.token-balances-card {
    background-color: var(--bg-white);
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(17, 69, 77, 0.08);
    overflow: hidden;
    margin-bottom: 24px;
    transition: all 0.3s ease;
  }

  .token-balances-card:hover {
    box-shadow: 0 8px 24px rgba(17, 69, 77, 0.12);
  }

  .token-balances-header {
    background: linear-gradient(135deg, rgba(17, 69, 77, 0.06) 0%, rgba(95, 184, 165, 0.06) 100%);
    padding: 18px 24px;
    border-bottom: 2px solid var(--border-gray);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .token-balances-header h3 {
    margin: 0;
    color: var(--primary-teal);
    font-size: 1.25rem;
    font-weight: 600;
  }

  .token-balances-refresh {
    background: none;
    border: none;
    color: var(--text-medium);
    font-size: 1.3rem;
    cursor: pointer;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.3s ease;
  }

  .token-balances-refresh:hover {
    background-color: rgba(17, 69, 77, 0.08);
    color: var(--primary-teal);
    transform: rotate(90deg);
  }

  .token-balances-body {
    padding: 24px;
  }

  .token-balances-loading,
  .token-balances-error,
  .token-balances-empty {
    padding: 24px 0;
    text-align: center;
    color: var(--text-medium);
  }

  .token-balances-loading {
    position: relative;
    padding-bottom: 48px;
  }

  .token-balances-loading::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 24px;
    height: 24px;
    border: 2px solid var(--border-gray);
    border-top-color: var(--primary-teal);
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  .token-balances-error {
    color: var(--error);
  }

  .token-balances-retry {
    background-color: var(--primary-teal);
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 10px;
    cursor: pointer;
    font-size: 0.95rem;
    margin-top: 12px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(17, 69, 77, 0.15);
  }

  .token-balances-retry:hover {
    background-color: var(--primary-teal-light);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(17, 69, 77, 0.25);
  }

  .token-table {
    width: 100%;
    border-collapse: collapse;
  }

  .token-table th,
  .token-table td {
    padding: 14px 12px;
    text-align: left;
    border-bottom: 1px solid var(--border-gray);
  }

  .token-table th {
    font-weight: 600;
    color: var(--primary-teal);
    background: linear-gradient(135deg, rgba(17, 69, 77, 0.03) 0%, rgba(95, 184, 165, 0.03) 100%);
    font-size: 0.95rem;
  }

  .token-table tr {
    transition: all 0.3s ease;
  }

  .token-table tr:hover {
    background: linear-gradient(90deg, rgba(17, 69, 77, 0.02) 0%, rgba(95, 184, 165, 0.02) 100%);
  }

  .token-mint {
    font-family: 'Monaco', 'Menlo', monospace;
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--text-dark);
    font-size: 0.9rem;
  }

  .token-amount {
    font-weight: 600;
    text-align: right;
    color: var(--primary-teal);
  }

  .token-decimals {
    text-align: center;
    color: var(--text-medium);
  }

  @keyframes spin {
    to {
      transform: translateX(-50%) rotate(360deg);
    }
  }
`, "",{"version":3,"sources":["webpack://./src/components/TokenBalances.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,mBAAmB;IACnB,6CAA6C;IAC7C,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,6FAA6F;IAC7F,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,wCAAwC;IACxC,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,eAAe;IACf,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,qCAAqC;IACrC,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,4CAA4C;EAC9C;;EAEA;IACE,2CAA2C;IAC3C,2BAA2B;IAC3B,6CAA6C;EAC/C;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,kBAAkB;IAClB,gBAAgB;IAChB,2CAA2C;EAC7C;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;IAC1B,6FAA6F;IAC7F,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,4FAA4F;EAC9F;;EAEA;IACE,yCAAyC;IACzC,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE;MACE,0CAA0C;IAC5C;EACF","sourcesContent":[".token-balances-card {\n    background-color: var(--bg-white);\n    border-radius: 16px;\n    box-shadow: 0 4px 16px rgba(17, 69, 77, 0.08);\n    overflow: hidden;\n    margin-bottom: 24px;\n    transition: all 0.3s ease;\n  }\n\n  .token-balances-card:hover {\n    box-shadow: 0 8px 24px rgba(17, 69, 77, 0.12);\n  }\n\n  .token-balances-header {\n    background: linear-gradient(135deg, rgba(17, 69, 77, 0.06) 0%, rgba(95, 184, 165, 0.06) 100%);\n    padding: 18px 24px;\n    border-bottom: 2px solid var(--border-gray);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .token-balances-header h3 {\n    margin: 0;\n    color: var(--primary-teal);\n    font-size: 1.25rem;\n    font-weight: 600;\n  }\n\n  .token-balances-refresh {\n    background: none;\n    border: none;\n    color: var(--text-medium);\n    font-size: 1.3rem;\n    cursor: pointer;\n    width: 36px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    transition: all 0.3s ease;\n  }\n\n  .token-balances-refresh:hover {\n    background-color: rgba(17, 69, 77, 0.08);\n    color: var(--primary-teal);\n    transform: rotate(90deg);\n  }\n\n  .token-balances-body {\n    padding: 24px;\n  }\n\n  .token-balances-loading,\n  .token-balances-error,\n  .token-balances-empty {\n    padding: 24px 0;\n    text-align: center;\n    color: var(--text-medium);\n  }\n\n  .token-balances-loading {\n    position: relative;\n    padding-bottom: 48px;\n  }\n\n  .token-balances-loading::after {\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    bottom: 0;\n    transform: translateX(-50%);\n    width: 24px;\n    height: 24px;\n    border: 2px solid var(--border-gray);\n    border-top-color: var(--primary-teal);\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n  }\n\n  .token-balances-error {\n    color: var(--error);\n  }\n\n  .token-balances-retry {\n    background-color: var(--primary-teal);\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 10px;\n    cursor: pointer;\n    font-size: 0.95rem;\n    margin-top: 12px;\n    transition: all 0.3s ease;\n    box-shadow: 0 2px 8px rgba(17, 69, 77, 0.15);\n  }\n\n  .token-balances-retry:hover {\n    background-color: var(--primary-teal-light);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(17, 69, 77, 0.25);\n  }\n\n  .token-table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n\n  .token-table th,\n  .token-table td {\n    padding: 14px 12px;\n    text-align: left;\n    border-bottom: 1px solid var(--border-gray);\n  }\n\n  .token-table th {\n    font-weight: 600;\n    color: var(--primary-teal);\n    background: linear-gradient(135deg, rgba(17, 69, 77, 0.03) 0%, rgba(95, 184, 165, 0.03) 100%);\n    font-size: 0.95rem;\n  }\n\n  .token-table tr {\n    transition: all 0.3s ease;\n  }\n\n  .token-table tr:hover {\n    background: linear-gradient(90deg, rgba(17, 69, 77, 0.02) 0%, rgba(95, 184, 165, 0.02) 100%);\n  }\n\n  .token-mint {\n    font-family: 'Monaco', 'Menlo', monospace;\n    max-width: 140px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: var(--text-dark);\n    font-size: 0.9rem;\n  }\n\n  .token-amount {\n    font-weight: 600;\n    text-align: right;\n    color: var(--primary-teal);\n  }\n\n  .token-decimals {\n    text-align: center;\n    color: var(--text-medium);\n  }\n\n  @keyframes spin {\n    to {\n      transform: translateX(-50%) rotate(360deg);\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
